<template>
  <Breadcrumb />
  <div class="d-flex justify-content-end">
    <router-link to="New" class="btn btn-success btn-action-new-page"
      ><i class="bi bi-plus"></i>
      {{
        $t("Holidays.NewButton", {}, { locale: this.$store.state.activeLang })
      }}</router-link
    >
  </div>
  <Grid :settings="gridSettings" :columns="gridColumns" />
</template>
<script>
export default {
  name: "CompanyHolidayList",
  components: {},
  data() {
    return {
      gridSettings: {
        action: "CompanyHolidayList",
        requestUrl: String.format("Lcdp-CompanyHolidayList"),
        requestUrlRouteParamNames: [],
        routeRequiredParameters: [
          {
            key: "holidayId",
            value: "publicId",
            isRouteParameter: false,
          },
        ],

        serialNoLink: `#/Holiday/Edit/`,
        isGatewayRequest: true,

        allowSearchPanel: true,
        allowExcelExport: true,
        allowDragAndDrop: false,
        allowPaging: true,
        allowDeleting: true,
        deleteActionUrl: "/Lcdp-CompanyHolidayDelete",
        autoOrderProcess: true,

        buttons: [
          {
            name: "edit",
            cssClass: "btn-warning",
            iconClass: "bi-pencil-square",
            routeButton: true,
            routeObj: {
              name: "HolidayEdit",
              params: {
                holidayId: "",
              },
            },
          },
        ],
      },
      gridColumns: [
        {
          text: this.$t(
            "Holidays.Name",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "name",
          type: "string",
          visible: true,
          width: 200,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Holidays.Day",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "day",
          type: "date",
          visible: true,
          width: 200,
          template: "",
          format: this.$store.getters._dateFormat,
          textAlign: "",
        },
        {
          text: this.$t(
            "Holidays.IsHalf",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "isHalf",
          type: "boolean",
          visible: true,
          width: 200,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "BaseModelFields.IsActive",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "isActive",
          type: "boolean",
          visible: true,
          width: 200,
          template: "",
          format: this.$store.getters._dateFormat,
          textAlign: "",
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
